import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#59AD3B",
      "fill-rule": "evenodd",
      d: "M10.418 1.5c3.45 0 6.25 2.8 6.25 6.25 0 1.796-.896 3.645-2.022 5.198-1.571 2.168-3.536 3.75-3.536 3.75-.404.324-.98.324-1.384 0 0 0-1.965-1.582-3.536-3.75-1.126-1.553-2.022-3.402-2.022-5.198 0-3.45 2.8-6.25 6.25-6.25Zm0 3.676a2.575 2.575 0 0 1 2.574 2.574 2.575 2.575 0 0 1-2.574 2.573A2.575 2.575 0 0 1 7.844 7.75a2.575 2.575 0 0 1 2.574-2.574Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }